import React from "react";
import { inject, observer } from "mobx-react";
import BaseMLBTrackingAccuracyReportContainer from "./BaseMLBTrackingAccuracyReportContainer";
import NonMLBTrackingAccuracyReportTable from "../components/accuracyReports/NonMLBTrackingAccuracyReportTable";
import IncidentTypes from "../constants/IncidentTypes";
import AmateurGameActionDropDownContainer from "./AmateurGameActionDropDownContainer";

class AmateurTrackingAccuracyReportContainer extends React.Component {
  render() {
    const rootStore = this.props.rootStore;
    const description =
      "A real-time pitch-by-pitch data report that monitors the overall quality of data and video systems used for Amateur games.";

    //May need to create a AmateurTrackingAccruacyRportTable
    const reportTable = (
      <NonMLBTrackingAccuracyReportTable
        data={
          rootStore.AmateurGameActionStore.trackingAccuracyReportSource.data
        }
        gameStatuses={rootStore.veracityStore.gameStatuses}
        canCreateIncident={rootStore.authStore.hasIncidentEdit}
        groupsToShow={rootStore.tableControlsStore.state}
        dropDownContainer={AmateurGameActionDropDownContainer}
      />
    );
    return (
      <BaseMLBTrackingAccuracyReportContainer
        header="Amateur Statcast Data & Coaching Video Report"
        description={description}
        reportSource={
          rootStore.AmateurGameActionStore.trackingAccuracyReportSource
        }
        reportTable={reportTable}
        incidentTypesToFetch={[IncidentTypes.Amateur, IncidentTypes.SYSTEM]}
        showSystemIncidentButton={rootStore.authStore.hasIncidentEdit}
      />
    );
  }
}

export default inject("rootStore")(
  observer(AmateurTrackingAccuracyReportContainer),
);
